export default date => `${formatDayOrMonth(date.getDate())}.${formatDayOrMonth(date.getMonth() + 1)}.${date.getFullYear()}`;


export const formatDayOrMonth = value => value < 10 ? `0${value}` : `${value}`;
